import { render, staticRenderFns } from "./dlgExportTreatment.vue?vue&type=template&id=a1024bcc"
import script from "./dlgExportTreatment.vue?vue&type=script&lang=js"
export * from "./dlgExportTreatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports